import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import Scene from '../3D/Scene';
import Godrays from '../3D/Godrays';
import Seabed from '../3D/seabed/Seabed';

// Footer: a més del comportament d'scroll-item normal, ancora un godray al seu .__target (2n render,
// underwater) i, a les pàgines amb escena (Home/About), el fons marí (3D/seabed) ancorat al propi footer.
// Overrides opcionals de posició del godray via data-attributes del target (data-offset-x/y, data-rotation) → veure Godrays.
class ScrollItem__Footer extends ScrollItem__BlockDefault {
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        const target = this.item.querySelector('.__godray-target');
        if (target) {
            this._godrays = new Godrays(target);
            Scene.addGodrays(this._godrays);
        }

        if (Scene.seabedEnabled) {
            this._seabed = new Seabed(this.item);
            Scene.addSeabed(this._seabed);
        }
    }

    resize(__w, __h) {
        super.resize(__w, __h);
        this._seabed?.resize(); // re-ancora al footer (alçada final del document)
    }

    dispose() {
        if (this._godrays) { Scene.removeGodrays(this._godrays); this._godrays = null; }
        if (this._seabed) { Scene.removeSeabed(this._seabed); this._seabed = null; }
        super.dispose();
    }
}

Scroll._registerClass('Footer', ScrollItem__Footer);

export default ScrollItem__Footer;
